// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"styles__container___3P9Qa","logo":"styles__logo___mXgts","text":"styles__text___VjJ4J"};
    if(module.hot) {
      // 1769468730040
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  